import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { ReportsContext } from '../../../context';
import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF, EXPORT_TEXT } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';
import { LOT_PROPS } from '../../../report-filters/report-paramter-input-properties';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_TEXT, EXPORT_CSV];

const filtersProps = [LOT_PROPS];

export const OrdersByLot = () => {
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);
  const { params } = useContext(ReportsContext);
  const isRunReportDisabled = !params?.lot;

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} isRunReportDisabled={isRunReportDisabled} />
    </>
  );
};
